import useDevice from 'hooks/useDevice';
import { products } from 'pages/ProductsAndServices/data';
import React, { useMemo } from 'react';
import Slider from 'react-slick';
import styled from 'styled-components';

const SlideStyled = styled(Slider)``;
export default function SlideIntroduce() {
	let settings = {
		dots: true,
		infinite: true,
		speed: 500,
		slidesToShow: 3,
		slidesToScroll: 1,
		arrows: true,
		dots: false,
	};

	const { widthWindow } = useDevice();

	const getWidthSlide = () => {
		let width = 1188;
		if (widthWindow > 500 && widthWindow < 1000) {
			settings.slidesToShow = 2;
			width = 700;
		} else if (widthWindow >= 1000 && widthWindow < 1200) {
			settings.slidesToShow = 3;
			width = 1000;
		}
		return width;
	};

	const slide = useMemo(() => {
		const widthSlide = getWidthSlide();
		return (
			<div className='mx-auto mt-56px' style={{ width: `${widthSlide}px` }}>
				<SlideStyled {...settings}>
					{products.map((item, index) => {
						return (
							<IntroItem
								key={index}
								title={item.title}
								content={item.content}
								img={item.img}
								link={item.link}
							/>
						);
					})}
				</SlideStyled>
			</div>
		);
	}, [widthWindow]);

	return slide;
}

const IntroItem = ({ title, content, img, link }) => {
	return (
		<div
			className='intro-item h-130px bg-acc mx-8px cursor-pointer'
			onClick={() => window.open(link)}
		>
			<div className='w-130px h-130px flex-shrink-0'>
				<img src={img} alt='' className='w-full h-full object-cover' />
			</div>
			<div className='text-212121 pl-20px pt-6px pr-26px pb-10px overflow-hidden'>
				<div className='h-full overflow-hidden'>
					<p className='text-16px font-roboto-medium'>{title}</p>
					<p className='text-13px text-opacity-80 leading-15px'>{content}</p>
				</div>
			</div>
		</div>
	);
};
